import React from 'react'
import { isMobile } from 'react-device-detect'

import { colors } from 'pixel-base'
import styled from 'styled-components'

interface InventoryProductSearchProps {
  search: string
  searchBySKU: boolean
  onSearchChange: (search: string) => void
  onSearchModeChange: (searchBySKU: boolean) => void
}

const InventoryProductSearch = ({
  search,
  searchBySKU,
  onSearchChange,
  onSearchModeChange,
}: InventoryProductSearchProps) => {
  const searchPlaceholder = searchBySKU
    ? 'Search by SKU'
    : 'Search by product name'

  return (
    <InventorySearchBar $mobile={isMobile}>
      <InventorySearchSelect
        aria-label="Search by"
        value={searchBySKU ? 'sku' : 'default'}
        onChange={(e) => onSearchModeChange(e.target.value === 'sku')}
      >
        <option value="default">SearchBy</option>
        <option value="sku">SKU</option>
      </InventorySearchSelect>
      <InventorySearchInput
        type="text"
        name="search"
        value={search}
        placeholder={searchPlaceholder}
        onChange={(e) => onSearchChange(e.target.value)}
        autoComplete="off"
      />
    </InventorySearchBar>
  )
}

const InventorySearchBar = styled.div<{ $mobile?: boolean }>`
  display: flex;
  align-items: stretch;
  flex: ${({ $mobile }) => ($mobile ? '1' : '0 0 auto')};
  max-width: ${({ $mobile }) => ($mobile ? 'none' : '300px')};
  min-width: 240px;
  height: 30px;
  border: 1px solid ${colors.grayInputBorder};
  border-radius: 4px;
  overflow: hidden;
  background: ${colors.white};
  margin-right: ${({ $mobile }) => ($mobile ? '36px' : '0')};

  &:focus-within {
    outline: none;
    box-shadow: none;
    border-color: ${colors.grayInputBorder};
  }
`

const InventorySearchSelect = styled.select`
  width: 100px;
  padding: 0 22px 0 10px;
  border: none;
  border-right: 1px solid ${colors.grayInputBorder};
  font-size: 14px;
  color: ${colors.grayInputDark};
  cursor: pointer;
  outline: none;
  box-shadow: none;
  appearance: none;
  background-color: ${colors.white};
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M3 4.5 6 7.5 9 4.5'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;

  &:focus {
    outline: none;
    box-shadow: none;
  }
`

const InventorySearchInput = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  box-shadow: none;
  padding: 0 10px;
  font-size: 14px;
  color: ${colors.grayInputDark};
  background: transparent;

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &::placeholder {
    color: ${colors.grayMedium};
  }
`

export default InventoryProductSearch
